import { render, staticRenderFns } from "./Sops.vue?vue&type=template&id=f6fb7e76&scoped=true&"
import script from "./Sops.vue?vue&type=script&lang=js&"
export * from "./Sops.vue?vue&type=script&lang=js&"
import style0 from "./Sops.vue?vue&type=style&index=0&id=f6fb7e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6fb7e76",
  null
  
)

export default component.exports